export const testImageConstants = {
  TEST_IMAGE_LOADING: "TEST_IMAGE_LOADING",
  TEST_IMAGE_SUCCESS: "TEST_IMAGE_SUCCESS",
  TEST_IMAGE_FAILURE: "TEST_IMAGE_FAILURE",
};
